import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import Keycloak from 'keycloak-js';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, MatIconModule],
  templateUrl: './app.html',
  styles: [`
    .app-switch {
      display: inline-flex; align-items: center; gap: 2px; padding: 3px;
      border-radius: 9999px; background: rgb(255 255 255 / 0.08);
      box-shadow: inset 0 0 0 1px rgb(255 255 255 / 0.08);
    }
    .app-switch-item {
      display: inline-flex; align-items: center; gap: 6px; height: 32px; padding: 0 14px;
      border-radius: 9999px; color: rgb(255 255 255 / 0.7); text-decoration: none;
      font-size: 0.85rem; font-weight: 500; white-space: nowrap;
      transition: background-color 120ms, color 120ms;
    }
    .app-switch-item mat-icon { width: 18px; height: 18px; font-size: 18px; }
    .app-switch-item:hover { color: var(--cp-contrast-light-100); background: rgb(255 255 255 / 0.08); }
    .app-switch-active,
    .app-switch-active:hover {
      background: var(--cp-contrast-light-100); color: var(--cp-primary-100); font-weight: 600;
    }
    .app-switch-active mat-icon { color: var(--cp-secondary-100); }
  `],
})
export class App {
  private readonly keycloak = inject(Keycloak);

  constructor() {
    // Dev-only: expose Keycloak instance on window for easy DevTools inspection.
    if (!environment.production) {
      (window as unknown as { kc: Keycloak }).kc = this.keycloak;
    }
  }

  protected readonly authenticated = computed(() => !!this.keycloak.authenticated);
  protected readonly username = computed(
    () => this.keycloak.tokenParsed?.['preferred_username'] as string | undefined
  );

  protected login(): void {
    void this.keycloak.login();
  }

  protected logout(): void {
    void this.keycloak.logout({ redirectUri: window.location.origin });
  }
}
